



















import { GetInvoiceResponse } from '@/classes/TayehApi/Instance';
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class InvoiceViewerInfoTable extends Vue {
    @Prop() invoice: GetInvoiceResponse;

    invoiceTypes = {
        'sold': 'فروش',
        'bought': 'خرید',
        'income': 'درآمد',
        'cost': 'هزینه'
    }

    
    public get customer() : string {
        return this.invoice.customer?.name
    }
    
}
